export default { 
    api_token: 'api_token',
    api_header: 'X-EF-Token',
    jwt_token: 'jwt',
    jwt_header: 'Authorization',
    ef_usuario: 'ef-usuario',
    ef_phpsession: 'ef-phpsession',
    last_selected_empresa_id: 'ef-empresa-id',
    filiais_session: 'filiais-session',
    selected_filiais: 'selected_filiais',
    selected_empresa: 'selected_empresa',
    empresa_change: 'empresa_change',
    empresa_add: 'empresa_add',
}
